import apiCall from "./apiCall";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  async createDeliveryNotee(data) {
    let response = await apiCall("delivery_notes/create", data);
    return response;
  },
  async fetchDeliveryNotess(data) {
    let response = await apiCall("delivery_notes/list_delivery_notes", data);
    return response;
  },
  async fetchDeliveryNoteDetails(data) {
    let response = await apiCall(
      "delivery_notes/get_delivery_note_details",
      data
    );
    return response;
  },
  async fetchDeliveryNotes_selectables(data) {
    let response = await apiCall(
      "delivery_notes/list_delivery_notes_selectables",
      data
    );
    return response;
  },
};
